function initializeMifoaWoolyV2(root = document) {
  root.querySelectorAll('[data-woolyv2-root]:not([data-woolyv2-ready])').forEach((module) => {
    module.dataset.woolyv2Ready = 'true';

    const gallery = module.querySelector('[data-woolyv2-gallery]');
    if (gallery) {
      const stageHost = gallery.querySelector('[data-woolyv2-stage-host]');
      const thumbs = [...gallery.querySelectorAll('[data-woolyv2-thumb]')];
      const activateImage = (index) => {
        if (!stageHost) return;
        let stage = stageHost.querySelector(`[data-woolyv2-stage="${index}"]`);
        if (!stage) {
          const template = stageHost.querySelector(`template[data-woolyv2-template="${index}"]`);
          const nextStage = template?.content.firstElementChild?.cloneNode(true);
          if (nextStage) {
            stageHost.appendChild(nextStage);
            stage = nextStage;
          }
        }
        stageHost.querySelectorAll('[data-woolyv2-stage]').forEach((item) => {
          const active = item === stage;
          item.hidden = !active;
          item.setAttribute('aria-hidden', String(!active));
        });
        thumbs.forEach((thumb) => {
          thumb.setAttribute('aria-pressed', String(thumb.dataset.woolyv2Thumb === String(index)));
        });
      };

      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => activateImage(thumb.dataset.woolyv2Thumb));
        thumb.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const nextIndex = (index + direction + thumbs.length) % thumbs.length;
          thumbs[nextIndex].focus();
          activateImage(thumbs[nextIndex].dataset.woolyv2Thumb);
        });
      });
    }

    module.querySelectorAll('[data-woolyv2-offer]:not([data-woolyv2-offer-ready])').forEach((offer) => {
      offer.dataset.woolyv2OfferReady = 'true';
      const form = offer.closest('form');
      const quantityInput = offer.querySelector('[data-woolyv2-quantity]');
      const options = [...offer.querySelectorAll('[data-woolyv2-tier]')];
      const saving = offer.querySelector('[data-woolyv2-saving]');
      const savingText = offer.querySelector('[data-woolyv2-saving-text]');
      const quantityValues = [...offer.querySelectorAll('[data-woolyv2-quantity-value]')];
      const quantityButtons = [...offer.querySelectorAll('[data-woolyv2-step]')];
      const addPriceElements = form ? [...form.querySelectorAll('[data-woolyv2-add-price]')] : [];
      const fallbackTotals = {
        1: offer.getAttribute('data-total-1') || '',
        2: offer.getAttribute('data-total-2') || '',
        3: offer.getAttribute('data-total-3') || '',
      };
      const fallbackSavings = {
        2: offer.getAttribute('data-save-2') || '',
        3: offer.getAttribute('data-save-3') || '',
      };
      const parseMap = (attribute, fallback) => {
        try {
          return { ...fallback, ...JSON.parse(offer.getAttribute(attribute) || '{}') };
        } catch (_error) {
          return fallback;
        }
      };
      const totals = parseMap('data-totals', fallbackTotals);
      const savings = parseMap('data-savings', fallbackSavings);
      const discounts = {
        2: offer.getAttribute('data-discount-2') || '',
        3: offer.getAttribute('data-discount-3') || '',
      };
      const unitPrice = Math.max(0, Number(offer.dataset.unitPrice) || 0);
      const discountCents = {
        2: Math.max(0, Number(offer.getAttribute('data-discount-2-cents')) || 0),
        3: Math.max(0, Number(offer.getAttribute('data-discount-3-cents')) || 0),
      };
      const quantityRule = {
        min: Math.max(1, Number(offer.dataset.quantityMin) || 1),
        max: Number(offer.dataset.quantityMax) > 0 ? Number(offer.dataset.quantityMax) : null,
        increment: Math.max(1, Number(offer.dataset.quantityIncrement) || 1),
      };
      const clampQuantity = (nextQuantity) => {
        const numeric = Number.isFinite(Number(nextQuantity)) ? Math.floor(Number(nextQuantity)) : quantityRule.min;
        const offset = Math.max(0, numeric - quantityRule.min);
        let normalized = quantityRule.min + Math.round(offset / quantityRule.increment) * quantityRule.increment;
        if (quantityRule.max !== null) normalized = Math.min(normalized, quantityRule.max);
        return Math.max(quantityRule.min, normalized);
      };
      const formatMoney = (cents) => {
        const safeCents = Math.max(0, Math.round(Number(cents) || 0));
        const fractionDigits = safeCents % 100 === 0 ? 0 : 2;
        const locale = (offer.dataset.currency || 'INR') === 'INR' && !/-IN$/i.test(offer.dataset.locale || '') ? 'en-IN' : offer.dataset.locale || 'en-IN';
        try {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: offer.dataset.currency || 'INR',
            currencyDisplay: 'narrowSymbol',
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits,
          }).format(safeCents / 100).replace(/\u00a0/g, ' ');
        } catch (_error) {
          return '₹' + (safeCents / 100).toLocaleString('en-IN', { maximumFractionDigits: fractionDigits });
        }
      };
      const amountFor = (nextQuantity) => {
        const tier = nextQuantity >= 3 ? 3 : nextQuantity >= 2 ? 2 : 1;
        const perUnitDiscount = tier > 1 ? discountCents[tier] : 0;
        const perUnit = Math.max(0, unitPrice - perUnitDiscount);
        return {
          perUnit,
          saving: perUnitDiscount * nextQuantity,
          total: perUnit * nextQuantity,
        };
      };
      const totalFor = (nextQuantity) => totals[nextQuantity] || formatMoney(amountFor(nextQuantity).total);
      const savingFor = (nextQuantity) => savings[nextQuantity] || formatMoney(amountFor(nextQuantity).saving);
      let quantity = clampQuantity(Number(offer.dataset.defaultQty) || 1);
      let sticky = offer.querySelector('[data-woolyv2-sticky]');

      if (sticky && form) {
        const moduleStyles = getComputedStyle(module);
        ['--w-accent', '--w-accent-dark'].forEach((property) => {
          const value = moduleStyles.getPropertyValue(property).trim();
          if (value) sticky.style.setProperty(property, value);
        });
        const stickyKey = form.id || 'woolyv2';
        sticky.dataset.woolyv2StickyKey = stickyKey;
        document.querySelectorAll(`body > [data-woolyv2-sticky][data-woolyv2-sticky-key="${stickyKey}"]`).forEach((item) => item.remove());
        document.body.appendChild(sticky);
      }

      const render = () => {
        if (quantityInput) {
          quantityInput.value = String(quantity);
          quantityInput.setAttribute('value', String(quantity));
        }
        const selectedTier = quantity >= 3 ? 3 : quantity;
        options.forEach((option) => {
          const active = Number(option.dataset.woolyv2Tier) === selectedTier;
          option.classList.toggle('is-selected', active);
          option.setAttribute('aria-checked', String(active));
        });
        quantityValues.forEach((element) => { element.textContent = String(quantity); });
        quantityButtons.forEach((button) => {
          const step = Number(button.dataset.woolyv2Step) || 0;
          const next = quantity + step * quantityRule.increment;
          button.disabled = next < quantityRule.min || (quantityRule.max !== null && next > quantityRule.max);
        });
        const currentTotal = totalFor(quantity);
        addPriceElements.forEach((element) => {
          element.textContent = currentTotal;
        });
        if (saving && savingText) {
          const hasSaving = quantity > 1 && amountFor(quantity).saving > 0;
          const discountTier = quantity >= 3 ? 3 : 2;
          saving.hidden = !hasSaving;
          savingText.textContent = hasSaving
            ? `${offer.dataset.savePrefix || ''} ${savingFor(quantity)} — ${discounts[discountTier]} ${offer.dataset.saveEachSuffix || ''}`.trim()
            : '';
        }
        const tierThree = options.find((option) => Number(option.dataset.woolyv2Tier) === 3);
        const tierThreeSave = tierThree?.querySelector('[data-woolyv2-tier-save]');
        const tierThreeTotal = tierThree?.querySelector('[data-woolyv2-tier-total]');
        const displayedTierQuantity = quantity >= 3 ? quantity : 3;
        const tierThreeAmounts = amountFor(displayedTierQuantity);
        if (tierThreeSave) tierThreeSave.textContent = `${offer.dataset.saveLabel || 'SAVE'} ${savingFor(displayedTierQuantity)}`.trim();
        if (tierThreeTotal) {
          tierThreeTotal.textContent = `${displayedTierQuantity} × ${formatMoney(tierThreeAmounts.perUnit)} = ${totalFor(displayedTierQuantity)} ${offer.dataset.totalLabel || 'total'}`;
        }
        if (sticky) {
          const selected = options.find((option) => Number(option.dataset.woolyv2Tier) === selectedTier);
          const selectedLabel = quantity > 3
            ? `${selected?.querySelector('.mf-woolyv2-tier__body strong')?.textContent?.trim() || 'Buy 3+'} · ${offer.dataset.quantityLabel || 'Quantity'} ${quantity}`
            : selected?.querySelector('.mf-woolyv2-tier__body strong')?.textContent?.trim() || '';
          const productName = module.querySelector('.mf-wooly-buy__meta span')?.textContent?.split('·')[0]?.trim() || '';
          const stickyLabel = sticky.querySelector('[data-woolyv2-sticky-label]');
          const stickyTotal = sticky.querySelector('[data-woolyv2-sticky-total]');
          if (stickyLabel) stickyLabel.textContent = `${productName} · ${selectedLabel}`;
          if (stickyTotal) stickyTotal.textContent = currentTotal;
        }
      };

      const setQuantity = (nextQuantity) => {
        quantity = clampQuantity(nextQuantity);
        render();
      };

      options.forEach((option, index) => {
        option.addEventListener('click', () => setQuantity(option.dataset.woolyv2Tier));
        option.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'ArrowUp' && event.key !== 'ArrowDown') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
          const nextIndex = (index + direction + options.length) % options.length;
          options[nextIndex].focus();
          setQuantity(options[nextIndex].dataset.woolyv2Tier);
        });
      });

      quantityButtons.forEach((button) => {
        button.addEventListener('click', () => {
          setQuantity(quantity + (Number(button.dataset.woolyv2Step) || 0) * quantityRule.increment);
        });
      });

      if (quantityInput) {
        new MutationObserver(() => {
          if (quantityInput.value !== String(quantity) || quantityInput.getAttribute('value') !== String(quantity)) {
            quantityInput.value = String(quantity);
            quantityInput.setAttribute('value', String(quantity));
          }
        }).observe(quantityInput, { attributes: true, attributeFilter: ['value'] });
      }

      if (sticky) {
        const primaryButton = form?.querySelector('.mf-wooly-buy__submit');
        const stickyButton = sticky.querySelector('[data-woolyv2-sticky-submit]');
        stickyButton?.addEventListener('click', () => {
          if (!form || !primaryButton || stickyButton.disabled) return;
          if (typeof form.requestSubmit === 'function') form.requestSubmit(primaryButton);
          else primaryButton.click();
        });
        const updateSticky = () => {
          if (!document.contains(sticky)) return;
          const pastPrimaryButton = primaryButton && primaryButton.getBoundingClientRect().bottom < 0;
          const footer = document.querySelector('.mf-footer') || document.querySelector('footer');
          const footerTop = footer?.getBoundingClientRect().top;
          const dock = footerTop ? Math.max(0, window.innerHeight - footerTop) : 0;
          sticky.style.bottom = dock > 0 ? `${dock}px` : '';
          sticky.classList.toggle('is-on', Boolean(pastPrimaryButton));
          sticky.setAttribute('aria-hidden', String(!pastPrimaryButton));
          document.body.classList.toggle('mf-has-sticky', Boolean(pastPrimaryButton));
        };
        window.addEventListener('scroll', updateSticky, { passive: true });
        updateSticky();
      }

      window.addEventListener('pageshow', render);
      render();
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeMifoaWoolyV2(document), { once: true });
} else {
  initializeMifoaWoolyV2(document);
}

document.addEventListener('shopify:section:load', (event) => initializeMifoaWoolyV2(event.target));
